import { ElLoading, ElMessage, ElMessageBox } from 'element-plus'

export const H5_SESSION_EXPIRED_MESSAGE = '长时间未操作，请重新登陆'

const modal = {
  success(message) { ElMessage.success(message) },
  error(error) {
    if (error?.h5SessionExpired) return
    const message = typeof error === 'string' ? error : error?.message
    ElMessage.error(message)
  },
  warning(message) { ElMessage.warning(message) },
  info(message) { ElMessage.info(message) },
  confirm(message, title = '提示') { return ElMessageBox.confirm(message, title, { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }) },
  prompt(message, title = '提示', options = {}) { return ElMessageBox.prompt(message, title, { confirmButtonText: '确定', cancelButtonText: '取消', inputType: 'textarea', inputPattern: /[\s\S]+/, inputErrorMessage: '请填写撤销原因', ...options }) },
  loading(text = '处理中...') { return ElLoading.service({ text, background: 'rgba(22, 55, 53, 0.25)' }) }
}

export default modal
